import { render, staticRenderFns } from "./StatisticsFault.vue?vue&type=template&id=23b65e81&scoped=true"
import script from "./StatisticsFault.vue?vue&type=script&lang=js"
export * from "./StatisticsFault.vue?vue&type=script&lang=js"
import style0 from "./StatisticsFault.vue?vue&type=style&index=0&id=23b65e81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b65e81",
  null
  
)

export default component.exports